import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FileUploader} from "../../../../../file-upload/file-uploader.class";
import {Draft} from "../../../../../../model/Draft";

@Component({
  selector: 'app-upload-pdf',
  templateUrl: './upload-pdf.component.html',
  styleUrls: ['./upload-pdf.component.css']
})
export class UploadPdfComponent implements OnInit {

  public hasBaseDropZoneOver: boolean = false;
  public uploader: FileUploader = new FileUploader( { } );
  private pdfFile: File;

  uploadFileMessages: string[] = [];
  uploadFileErrorMessages: string[] = [];

  draft: Draft;

  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) data, public dialogRef: MatDialogRef<UploadPdfComponent>) {
    if (data.draft) {
      this.draft = data.draft;
    }
  }

  public fileOverBase( e: any ): void {
    this.hasBaseDropZoneOver = e;
  }

  onFileSelected(event: any) {
    const file = event.target?.files?.[0];
    if (file) {
      this.fileAdded(file);
    }
  }

  fileAdded(file: File) {
    if (file) {
      if (!file.name.toLowerCase().endsWith('.pdf')) {
        this.uploadFileErrorMessages = ['Only PDF files are accepted.'];
        return;
      }
      this.pdfFile = file;
      this.uploadFileMessages = [`File selected: ${file.name} (${(file.size / 1024).toFixed(1)} KB)`];
      this.uploadFileErrorMessages = [];
      // TODO: Upload the PDF via ResourceService, create a Resource, and attach the resource_ID
      // to this.draft.draftBody.resource_ID or this.draft.draftCover.resource_ID
    } else {
      this.uploadFileErrorMessages = ['No file selected.'];
    }
  }

  public ngOnInit(): void {
  }
}
